import React from 'react';
import { Link } from 'react-router-dom';
import PageTransition from '../components/PageTransition';

function NotFound() {
  return (
    <PageTransition>
      <div style={{
        minHeight: '70vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '120px 24px',
        textAlign: 'center',
        background: 'var(--clr-white)',
      }}>
        <h1 style={{
          fontSize: 'clamp(4rem, 8vw, 6rem)',
          fontFamily: 'var(--font-heading)',
          color: 'var(--clr-navy)',
          margin: 0,
          lineHeight: 1,
        }}>404</h1>
        <div style={{
          width: '60px',
          height: '4px',
          background: 'var(--clr-accent-gold)',
          margin: '24px 0',
        }}></div>
        <h2 style={{
          fontSize: '1.5rem',
          color: 'var(--clr-navy)',
          fontWeight: 600,
          marginBottom: '16px',
        }}>Page Not Found</h2>
        <p style={{
          fontSize: '1rem',
          color: 'var(--clr-text-light)',
          maxWidth: '500px',
          lineHeight: 1.6,
          marginBottom: '40px',
        }}>
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        <Link to="/" className="byhw-cta">Return to Homepage</Link>
      </div>
    </PageTransition>
  );
}

export default NotFound;
